import { Component, OnInit, ViewChild } from '@angular/core';
import { MatDrawer } from '@angular/material/sidenav'
import { PageEvent, MatSnackBar } from '@angular/material';
import { SessionService } from '../../../service/session/session.module';
import * as Rx from 'rxjs';
// import { LoadingService } from '../../../directive/loading/loading.module';
// import * as moment from 'moment';

@Component({
  selector: 'app-measurement',
  templateUrl: './measurement.component.html',
  styleUrls: ['./measurement.component.css']
})
export class MeasurementComponent implements OnInit {
  @ViewChild('drawer',{static:true})drawerCtrl: MatDrawer;

  paginatorModel = {
    total:0,
    pageSizeOptions:[ 2 ,5, 10, 25, 100, 200, 500, 1000],
  };
  metadata = {
    searchBoxInput: new Rx.Subject<string>(),
    object:{
      main:{
        uuid:''
      }
    }
  }
  // MatPaginator Output
  pageEvent: PageEvent;

  measurementList = [];
  measurementMin = {
    system:{
      status:true
    },
    max: 10,
    offset: 0,
    filter:{
      name:'',
      value: ''
    }
  }
  constructor(private session: SessionService, public snackBar: MatSnackBar) {
  //   this.metadata.searchBoxInput.debounceTime(700)
  //   .switchMap(val => {
  //     // console.log('called once',val)
  //     if(val != ''){
  //       this.measurementList = [];
  //       this.measurementMin.filter.name = 'searchElement';
  //     }else{
  //       this.measurementList = [];
  //       this.measurementMin.filter.name = '';
  //       this.measurementMin.filter.value = '';
  //       val = 'false'
  //     }
  //     this.getMeasurementList();
  //     return val;
  //   }).subscribe(results => {
  //     // Modificaciones sobre cada letra si se requiere
  //   }, error => {
  //   console.log('error logged:');
  //   this.snackBar.open(error.message, 'Error', {duration: 5000});
  //   console.log(error);
  // });
   }

  ngOnInit() {
    this.getMeasurementList();
    this.drawerCtrl.opened = true;
  }

  // funcion para obtener la lista de medidas
  getMeasurementList() {
  // this.loadingService.wait();
    this.measurementList = [];
    // verificamos en que pagina verificamos
    this.session.getRequest("unitMeasure:list", this.measurementMin).subscribe(
      (data: any) => {
        this.measurementList = data.object.instanceList;
        this.paginatorModel.total = data.object.total;
        // this.loadingService.hide();
      },
      error => {
        console.log("unitMeasure:list", error);
        // this.loadingService.hide();
      }
    );
  }

  /*
  Funcion para inactivar una unidad de medida
  */
  disableAMeasurement(object) {
    object.system.status = false;
    // this.loadingService.wait();
    this.session.getRequest("unitMeasure:update", object).subscribe(
      data => {
        this.snackBar.open('Unidad de Medida desactivada correctamente', '', {
          duration: 8000
        });
        // this.loadingService.hide();
        for (var _i = 0; _i < this.measurementList.length; _i++) {
          if (object.main.uuid == this.measurementList[_i].main.uuid) {
            this.measurementList.splice(_i, 1);
            break;
          }
        }
      },
      error => {
        console.log("Erro: unitMeasure:update", error);
        // this.loadingService.hide();
      }
    );
  }

  /*
  Funcionalidad para colocar el objeto en el menu de opciones
  */
  objectSelected(object){
    for(let i=0; i < this.measurementList.length; i++){
      this.measurementList[i].system.selected = false;
    }
    if(object.main.uuid == this.metadata.object.main.uuid){
      object.system.selected = false;
      this.metadata.object.main.uuid = '';
    }else{
      object.system.selected = true;
      this.metadata.object = JSON.parse(JSON.stringify(object));;
    }
  }

  /*
    *Funcion para buscar
  */
  search(){
    this.metadata.searchBoxInput.next(this.measurementMin.filter.value);
  }
  // funcion para obtener los datos del paginado.
  onPaginateChange(event){
    this.measurementMin.offset = (event.pageIndex * event.pageSize);
    this.measurementMin.max = event.pageSize;
    this.getMeasurementList();
  }

  handleUpdated(event) {
    this.measurementMin.offset = (this.pageEvent ? this.pageEvent.pageIndex * this.pageEvent.pageSize  : this.measurementMin.offset);
    this.getMeasurementList();
  }
 /*
 funcion para controlar si se abre o cierra el menu
 */
 toogleMenu(ev){
   this.drawerCtrl.opened = ev;
 }

}
